import axios from 'axios';
import { useSyncExternalStore } from 'react';

// Per-download document language (PL/EN). Only active when an admin enabled
// `doc_language_choice` for the user; every request then carries X-Doc-Lang.
let state = { enabled: false, lang: 'en' };
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());

export const initDocLang = (user) => {
  state = { enabled: !!user?.doc_language_choice, lang: (user?.preferred_language || 'en').toLowerCase() };
  emit();
};

export const setDocLang = (lang) => {
  state = { ...state, lang };
  emit();
};

/** Language for documents that pass it explicitly in the request body. */
export const currentDocLang = () => state.lang;

// Only document downloads carry the override, never ordinary API calls.
const DOC_URL = /(pdf|excel|xlsx|export|report|print|pack|certificate|download)/i;
const wantsHeader = (url) => state.enabled && DOC_URL.test(String(url || ''));

export const useDocLang = () => useSyncExternalStore(
  (cb) => { listeners.add(cb); return () => listeners.delete(cb); },
  () => state,
);

axios.interceptors.request.use((config) => {
  if (wantsHeader(config.url)) {
    config.headers = config.headers || {};
    config.headers['X-Doc-Lang'] = state.lang;
  }
  return config;
});

const nativeFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => {
  const url = typeof input === 'string' ? input : input?.url;
  if (!wantsHeader(url)) return nativeFetch(input, init);
  const headers = new Headers(init.headers || (typeof input === 'string' ? undefined : input.headers));
  headers.set('X-Doc-Lang', state.lang);
  return nativeFetch(input, { ...init, headers });
};
